import { Fetch, Resource } from '@ekuaibao/fetch';
import { getFirstScreenRoute } from './initRoute';
import { app } from '@ekuaibao/whispered';
import { getBoolVariation } from '../lib/featbit';
var _prefetchCache = {};
window.__FMP_PREFETCH__ = _prefetchCache;
var _prefetchStarted = false;
var DEFAULT_MENU_TYPE = 'MAIN_FRAME_DESKTOP';
var HOMEPAGE_CARD_CODES = ['myBill', 'myLoan', 'auditPending'];
var markPromiseSettled = function (promise, markName) {
    promise.then(function () { return performance.mark(markName); }, function () { return performance.mark(markName); });
    return promise;
};
export function startPrefetch() {
    if (_prefetchStarted) {
        return;
    }
    _prefetchStarted = true;
    performance.mark('fmpPrefetchStart');
    var route = getFirstScreenRoute();
    var prefetchPromises = [];
    prefetchPromises.push(prefetchMenuFilterPower());
    prefetchPromises.push(prefetchMenuList());
    if (route === '/new-homepage') {
        prefetchPromises.push(prefetchHomepageCards());
        prefetchPromises.push(prefetchHomepageMyBills());
    }
    if (route === '/bills') {
        prefetchPromises.push(prefetchBillsList());
    }
    Promise.all(prefetchPromises).then(function () {
        performance.mark('fmpPrefetchEnd');
    });
    console.info('[FMP] Prefetch started for route:', route);
}
function prefetchMenuFilterPower() {
    performance.mark('fmpPrefetchMenuPowerStart');
    var key = "menu:filterPower";
    var powserCode = '110302';
    _prefetchCache[key] = Fetch.GET("/api/charge/powers/detail/$" + powserCode, null, null, { hiddenLoading: true }).then(function (res) {
        var _a;
        var hasPower = ['using', 'free'].includes((_a = res === null || res === void 0 ? void 0 : res.value) === null || _a === void 0 ? void 0 : _a.state);
        return hasPower;
    }).catch(function (err) {
        if ((err === null || err === void 0 ? void 0 : err.errorCode) === 403) {
            return false;
        }
        console.warn('[FMP] Menu filter power prefetch failed:', err);
        delete _prefetchCache[key];
        return null;
    });
    markPromiseSettled(_prefetchCache[key], 'fmpPrefetchMenuPowerEnd');
    return _prefetchCache[key];
}
function prefetchMenuList() {
    performance.mark('fmpPrefetchMenuListStart');
    var url = "/api/menu/v2/menus/byDeviceTypeAndAppId/$" + DEFAULT_MENU_TYPE;
    var key = "menu:" + DEFAULT_MENU_TYPE;
    _prefetchCache[key] = Fetch.GET(url, undefined, undefined, { hiddenLoading: true }).catch(function (err) {
        console.warn('[FMP] Menu prefetch failed:', err);
        delete _prefetchCache[key];
        return null;
    });
    markPromiseSettled(_prefetchCache[key], 'fmpPrefetchMenuListEnd');
    return _prefetchCache[key];
}
function prefetchHomepageCards() {
    performance.mark('fmpPrefetchHomepageCardsStart');
    var key = 'homepage:cards';
    var businesssummary = new Resource('/api/menu/v2/businesssummary');
    _prefetchCache[key] = businesssummary.POST('', { deviceType: 'MOBILE', codes: HOMEPAGE_CARD_CODES }, undefined, undefined, { hiddenLoading: true }).catch(function (err) {
        console.warn('[FMP] Homepage cards prefetch failed:', err);
        delete _prefetchCache[key];
        return null;
    });
    markPromiseSettled(_prefetchCache[key], 'fmpPrefetchHomepageCardsEnd');
    return _prefetchCache[key];
}
function prefetchHomepageMyBills() {
    performance.mark('fmpPrefetchHomepageMyBillsStart');
    var key = 'homepage:myBills';
    if (!getBoolVariation('mfrd-4849-my-bills-data-consistency')) {
        performance.mark('fmpPrefetchHomepageMyBillsEnd');
        return Promise.resolve(null);
    }
    try {
        var BillListService = app.require('@lib/billListService').BillListService;
        _prefetchCache[key] = new BillListService()
            .getBillList({}, { start: 0, pageSize: 3 }, { skipUserInfoLoad: true })
            .catch(function (err) {
            console.warn('[FMP] Homepage myBills prefetch failed:', err);
            delete _prefetchCache[key];
            return null;
        });
    }
    catch (error) {
        console.warn('[FMP] Homepage myBills prefetch setup failed:', error);
        performance.mark('fmpPrefetchHomepageMyBillsEnd');
        return Promise.resolve(null);
    }
    markPromiseSettled(_prefetchCache[key], 'fmpPrefetchHomepageMyBillsEnd');
    return _prefetchCache[key];
}
function prefetchBillsList() {
    performance.mark('fmpPrefetchBillsListStart');
    try {
        var promise = Promise.resolve(app.invokeService('@bills:prefetch:first-screen-list')).catch(function (error) {
            console.warn('[FMP] Bills list prefetch failed:', error);
            return null;
        });
        markPromiseSettled(promise, 'fmpPrefetchBillsListEnd');
        return promise;
    }
    catch (error) {
        console.warn('[FMP] Bills list prefetch setup failed:', error);
        performance.mark('fmpPrefetchBillsListEnd');
        return Promise.resolve(null);
    }
}
